<template>
    <div class=video-page>

        <div class=video>

            <InlineVideo :video="post.acf.video" :subtitles="post.acf.subtitles" :image="post.acf.video_placeholder" :showControls="true" />

        </div>

        <PageDescription :post="post" />

    </div>
</template>
<script>
import PageDescription from '../components/PageDescription';
import InlineVideo from '../components/InlineVideo';

export default {
    name : 'VideoPage',
    props : {
        post         : Object   ,
    },
    components : {
        PageDescription ,
        InlineVideo     ,
    }
}
</script>